import React, { useState, useEffect } from "react";
import "../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { ContentEditableEditor } from "./EditorConvertToMarkdown.styled";
import { convertToRaw, ContentState, EditorState, Modifier } from "draft-js";
import { Editor } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";

const EditorConvertToMarkdown = ({
  editor,
  setEditor,
  style,
  placeHolder,
  disableTextArea,
  sendVariable,
  showOnFocus = true,
}) => {
  const [editorState, setEditorState] = useState();
  const [changeDescription, setChangeDescription] = useState();
  const [newEditor] = useState();
  const onEditorStateChange = (editorState) => {
    let content = draftToHtml(convertToRaw(editorState.getCurrentContent()));
    setChangeDescription(editorState);
    setEditor(content);
  };
  useEffect(() => {
    if (!changeDescription) {
      const contentBlock = htmlToDraft(editor);
      if (contentBlock) {
        const contentState = ContentState.createFromBlockArray(
          contentBlock.contentBlocks
        );
        const newEditorState = EditorState.createWithContent(contentState);
        setEditorState(newEditorState);
      }
    } else {
      setEditorState(changeDescription);
    }
  }, [editor, changeDescription]);

  useEffect(() => {
    if (sendVariable) {
      sendTextToEditor(sendVariable);
    }
  }, [sendVariable]);

  let focusEditor = () => {
    if (newEditor) {
      newEditor.focusEditor();
    }
  };

  let sendTextToEditor = (text) => {
    setEditorState(insertText(text, editorState));
    focusEditor();
  };

  let insertText = (text, editorState) => {
    const currentContent = editorState.getCurrentContent(),
      currentSelection = editorState.getSelection();

    const newContent = Modifier.replaceText(
      currentContent,
      currentSelection,
      text
    );

    const newEditorState = EditorState.push(
      editorState,
      newContent,
      "insert-characters"
    );
    return EditorState.forceSelection(
      newEditorState,
      newContent.getSelectionAfter()
    );
  };

  return (
    <ContentEditableEditor style={style} showOnFocus={showOnFocus}>
      <Editor
        toolbar={{
          options: [
            "inline",
            "blockType",
            "fontSize",
            "fontFamily",
            "list",
            "textAlign",
            "colorPicker",
            "link",
            "remove",
            "history",
          ],
          fontFamily: {
            options: [
              "Arial",
              "Georgia",
              "Impact",
              "Tahoma",
              "Times New Roman",
              "Verdana",
              "Abel",
              "Abril Fatface",
              "Anton",
              "Archivo Narrow",
              "Archivo",
              "Arimo",
              "Arvo",
              "Asap",
              "Assistant",
              "Barlow Condensed",
              "Barlow",
              "Bebas Neue",
              "Bitter",
              "Cabin",
              "Cairo",
              "Catamaran",
              "Caveat",
              "Comfortaa",
              "Cormorant Garamond",
              "Dancing Script",
              "DM Sans",
              "Dosis",
              "EB Garamond",
              "Exo 2",
              "Fira Sans Condensed",
              "Fira Sans",
              "Fjalla One",
              "Heebo",
              "Hind Madurai",
              "Hind Siliguri",
              "Hind",
              "IBM Plex Sans",
              "IBM Plex Serif",
              "Inconsolata",
              "Indie Flower",
              "Inter",
              "Josefin Sans",
              "Kanit",
              "Karla",
              "Lato",
              "Libre Baskerville",
              "Libre Franklin",
              "Lobster",
              "Lora",
              "M PLUS Rounded 1c",
              "Manrope",
              "Maven Pro",
              "Merriweather Sans",
              "Merriweather",
              "Montserrat",
              "Mukta",
              "Mulish",
              "Nanum Gothic",
              "Noto Sans HK",
              "Noto Sans JP",
              "Noto Sans KR",
              "Noto Sans SC",
              "Noto Sans TC",
              "Noto Sans",
              "Noto Serif JP",
              "Noto Serif",
              "Nunito Sans",
              "Nunito",
              "Oswald",
              "Overpass",
              "Oxygen",
              "Pacifico",
              "Padauk",
              "Permanent Marker",
              "Playfair Display",
              "Poppins",
              "Prompt",
              "PT Sans Narrow",
              "PT Sans",
              "PT Serif",
              "Questrial",
              "Quicksand",
              "Rajdhani",
              "Raleway",
              "Roboto Condensed",
              "Roboto Mono",
              "Roboto Slab",
              "Roboto",
              "Rubik",
              "Saira Condensed",
              "Secular One",
              "Shadows Into Light",
              "Signika Negative",
              "Slabo 27px",
              "Source Code Pro",
              "Source Sans Pro",
              "Source Serif Pro",
              "Teko",
              "Titillium Web",
              "Ubuntu Mono",
              "Ubuntu",
              "Varela Round",
              "Work Sans",
              "Yanone Kaffeesatz",
            ],
          },
          inline: { inDropdown: true },
          blockType: { inDropdown: true },
          list: { inDropdown: true },
          textAlign: { inDropdown: true },
          colorPicker: { inDropdown: true },
          link: { inDropdown: true },
          history: { inDropdown: true },
        }}
        wrapperClassName="wrapper-class"
        editorClassName="editor-class"
        toolbarClassName="rich-text__toolbar"
        editorState={editorState}
        onEditorStateChange={onEditorStateChange}
        placeholder={placeHolder ? placeHolder : ""}
        readOnly={disableTextArea}
      />
    </ContentEditableEditor>
  );
};

export default EditorConvertToMarkdown;
